module.exports = __webpack_public_path__ + "security-88f38344.webp";